const en = {
  description: `The biggest free library of
cognitive biases (thinking patterns)
with over a thousand use cases.`,
};
export default en;
